import { Button, Flex, Input, message } from "antd"
import { ChangeEvent, FC, useState } from "react"
import { generateRandomPassword } from "../api/customersApi"

interface IPassword {
  setFormPassword: (password: string) => void
}

const Password: FC<IPassword> = ({ setFormPassword }) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [password, setPassword] = useState<string>()

  function generatePassword() {
    setIsLoading(true)

    generateRandomPassword()
      .then((res) => {
        setPassword(res)
        setFormPassword(res)
      })
      .catch((e) => {
        message.error("Error generate password")
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  function onChangePassword(value: ChangeEvent<HTMLInputElement>) {
    setPassword(value.target.value)
    setFormPassword(value.target.value)
  }

  return (
    <Flex gap="10px">
      <Input
        placeholder="Password"
        value={password}
        onChange={(value) => onChangePassword(value)}
      />
      <Button onClick={generatePassword} loading={isLoading} disabled={isLoading}>
        generate
      </Button>
    </Flex>
  )
}

export default Password
